<template>
	<a-form-model :model="formview" layout="inline" id='view_froms'>
		<div :class='viewpaif&&!formview.cn_name?"warp_red":""'>
			<a-form-model-item label="中文名稱">
				<a-input v-model="formview.cn_name" auto-complate='on' :read-only='disabled' @input="checkForm('cn_name')"/>
			</a-form-model-item>
		</div>
		<div :class='viewpaif&&!formview.en_name?"warp_red":""'>
			<a-form-model-item label="英文名稱">
				<a-input v-model="formview.en_name" auto-complate='on' :read-only='disabled' @input="checkForm('en_name')"/>
			</a-form-model-item>
		</div>
		<div :class='viewpaif&&!formview.phonenum?"warp_red":""'>
			<a-form-model-item label="電話號碼">
				<a-input v-model="formview.phonenum" auto-complate='on' :read-only='disabled'/>
				<!-- <a-row>
					<a-col :span="13">
						<a-select v-model="formview.nationcode" id="warp_input" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">>
							<a-select-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value"
								:value="item.value">
								<span style="font-size:.8rem;float: left">{{ item.label }}</span>
								<span style="font-size:.8rem;float: right;">+{{ item.value }}</span>
							</a-select-option>
						</a-select>
					</a-col>
					<a-col :span="11">
						<a-input v-model="formview.phonenum">
						</a-input>
					</a-col>
				</a-row> -->
			</a-form-model-item>
		</div>
		<div :class='viewpaif&&!formview.email?"warp_red":""'>
			<a-form-model-item label="電郵地址">
				<a-input v-model="formview.email" auto-complate='on' :read-only='disabled'/>
			</a-form-model-item>
		</div>
		<div :class='viewpaif&&!formview.id_number?"warp_red":""'>
			<a-form-model-item label="身份信息">
				<a-input v-model="formview.id_number" auto-complate='on' :read-only='disabled'  @input="checkForm()"/>
			</a-form-model-item>
		</div>
		<div :class='viewpaif&&!formview.address?"warp_red":""'>
			<a-form-model-item label="地址信息">
				<a-input v-model="formview.address" type="textarea" auto-complate='on' :read-only='disabled'/>
			</a-form-model-item>
		</div>
		<div style="margin-top: 10px;width: 0.0625rem;height: 1px;">
			<!-- <a-button class="tableBzViewBtn" @click='$emit("child",false)'>取消</a-button>
			<a-button  class="tableBzViewBtn" style="margin-left: 110px;color: #fff;" type="primary" @click='imfrom()'>
			      保存
			    </a-button> -->
		</div>
	</a-form-model>
</template>

<script>
	 import App from '@/assets/app.js';
	export default {
		props: ['record'],
		data() {
			return {
				formview: {
					address: "",
					cn_name: "",
					email: "",
					en_name: "",
					id_number: "",
					khid: "",
					nationcode: "",
					phonenum: "",
				},
				disabled:(this.record.schedule > 1) || (this.record.schedule == 1 && this.record.status == 0) ,
				viewpaif:0,
				// 手機區號列表
				qhArr: [{
						id: '1',
						value: '86',
						label: '中國'
					},
					{
						id: '2',
						value: '852',
						label: '中國香港'
					},
					{
						id: '3',
						value: '853',
						label: '中國澳門'
					},
					{
						id: '4',
						value: '61',
						label: '澳大利亞'
					},
					{
						id: '5',
						value: '1',
						label: '加拿大'
					},
					{
						id: '6',
						value: '60',
						label: '馬來西亞'
					},
					{
						id: '7',
						value: '1',
						label: '美國'
					},
					{
						id: '8',
						value: '65',
						label: '新加坡'
					},
					{
						id: '9',
						value: '64',
						label: '新西蘭'
					},
					{
						id: '10',
						value: '44',
						label: '英國'
					}
				],
			}
		},
		mounted() {
			this.handimg(this.record)
			console.log(this.record.schedule)
		},
		methods: {
			checkForm(data) {
				if (data == 'en_name') {
					this.formview.en_name = this.formview.en_name.replace(/[^A-Za-z|\s*]+/g, "").replace(/\s+/g, " ").replace(/(^\s*)/g,
						'');
				} else if (data == 'cn_name') {
					this.formview.cn_name = this.formview.cn_name.replace(/[^\u4e00-\u9fa5]+/g, '').replace(/(^\s*)/g, '');
				}else{
					this.formview.id_number = this.formview.id_number.replace(/[^A-Za-z|0-9\s*]+/g, "").replace(/\s+/g, " ").replace(/(^\s*)/g,
						'');
				}
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getNewJbxx,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"khid": record.pdfcode
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data.result
						this.formview.khid = record.pdfcode
						console.log(this.formview)
					}
				})
			},
			imfrom() {
				this.viewpaif++
				this.formview.token = ''
				this.formview.token = this.$store.state.token
				let statem = 0
				for(let key in this.formview){
					if(!this.formview[key]){
						statem = 1
					}
				}
				if(statem){
					return
				}else{
					return this.formview
				}
				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.editNewJbxx,
				// 	headers: {
				// 		token: this.$store.state.token
				// 	},
				// 	data: this.formview
				// }).then(res => {
				// 	console.log(res)
				// 	if (res.data.qmiscode === 1000) {
				// 		 App.oTool.successT('操作成功');
				// 		this.$emit('child',false)
				// 	}
				// })
			}
		}
	}
</script>

<style lang='scss'>
	#view_froms {
		div{
			margin-bottom: .1rem;
		}
		.ant-form-item-label {
			label{
				font-size: .8rem !important;
			}
		}
		.ant-form-item{
			 width: calc(100% + .2rem);
		}
		.ant-form-item-control-wrapper{
			width: calc(100% - 4.3rem);
		}
		.warp_red {
			label {
				color: red;
			}
		}

		.tableBzViewBtn {
			
			margin: 0 0.5rem;
			/* outline: none; */
		}

		.ant-input {
			/* border: none;
			outline: none;

			&:hover {
				border: none;
			}

			&:focus {
				border: none;
				box-shadow: 0 0 0 0 #fff !important;
			} */
		}
	}

/* 	#view_from>div:nth-child(1) {
		border: 1px solid #d9d9d9;
		border-radius: 4px 4px 0 0;
	}

	#view_from>div:nth-child(2) {
		border: 1px solid #d9d9d9;
		border-top: none;
	}

	#view_from>div:nth-child(3) {
		border: 1px solid #d9d9d9;
		border-top: none;
	}

	#view_from>div:nth-child(4) {
		border: 1px solid #d9d9d9;
		border-top: none;
	}

	#view_from>div:nth-child(5) {
		border: 1px solid #d9d9d9;
		border-top: none;
	} */

	#view_froms>div:nth-child(6) {
		/* border: 1px solid #d9d9d9; */
		/* //f3f3f3 */
		/* border-radius: 0 0 4px 4px;
		border-top: none; */
		.ant-input {
			margin-top: 5px;
			margin-right: -5px;
		}
	}
</style>
